import { computed } from 'mobx';
import { IComputedValue } from 'mobx';

const isActionColumn: IComputedValue<boolean> = computed(() => {
  return true;
});

export { isActionColumn };
